import React from "react";
import { Typography, Button, Stack, Modal, Box, IconButton } from "@mui/material";
import { English } from "../../constant/EnglishFallback";
import { useSelector } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from "@mui/icons-material/Error";

function DeleteConfirmation({
  open,
  onClose,
  headerText = "Confirm Action",
  secondaryText = "Are you sure you want to proceed? This action cannot be undone.",
  onBadgeClick,
  actionBtnText
}) {
  const { multiLanguageData } = useSelector((state) => state?.main);

  const {
    BUTTON_GOBACK = English?.Profile?.BUTTON_GOBACK,
    BUTTON_OK = English?.Profile?.BUTTON_OK
  } = multiLanguageData?.Profile || {};

  return (
    <Modal
      open={open}
      onClose={onClose}
      closeAfterTransition
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backdropFilter: "blur(4px)",
        p: 2
      }}
    >
      <Box
        sx={{
          bgcolor: "background.paper",
          borderRadius: "24px",
          boxShadow: "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
          p: 3,
          width: "100%",
          maxWidth: "400px",
          position: "relative",
          outline: "none"
        }}
      >
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: "text.secondary"
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>

        <Stack sx={{ mt: 1,  alignItems: "center" }} spacing={2} textAlign="center" >
          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: "50%",
              bgcolor: "#fee2e2",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#ef4444"
            }}
          >
            <ErrorIcon sx={{ fontSize: 28 }} />
          </Box>

          <Box sx={{ textAlign: "center" }}>
            <Typography sx={{ fontWeight: 700, color: "#1e293b", textAlign: "center" }} variant="h6" gutterBottom>
              {headerText}
            </Typography>
            <Typography variant="body2"  sx={{color: "text.secondary",  lineHeight: 1.5, textAlign: "center" }}>
              {secondaryText}
            </Typography>
          </Box>

          <Stack
            sx={{
              flexDirection: "row",
              gap: 1.5,
              width: "100%",
              pt: 1
            }}>
            <Button
              fullWidth
              variant="outlined"
              onClick={onClose}
              sx={{
                flex: 1,
                borderRadius: "10px",
                textTransform: "none",
                fontWeight: 600,
                color: "#64748b",
                borderColor: "#e2e8f0",
                py: 1,
                "&:hover": {
                  borderColor: "#cbd5e1",
                  bgcolor: "#f8fafc",
                  color: "#334155"
                }
              }}
            >
              {BUTTON_GOBACK}
            </Button>
            <Button
              fullWidth
              variant="contained"
              onClick={onBadgeClick}
              sx={{
                flex: 1,
                borderRadius: "10px",
                textTransform: "none",
                fontWeight: 600,
                bgcolor: "#ef4444",
                boxShadow: "0 1px 2px 0 rgb(0 0 0 / 0.05)",
                py: 1,
                "&:hover": {
                  bgcolor: "#dc2626",
                  boxShadow: "0 4px 6px -1px rgb(239 68 68 / 0.2)"
                }
              }}
            >
              {actionBtnText ?? BUTTON_OK}
            </Button>
          </Stack>
        </Stack>
      </Box>
    </Modal>
  );
}

export default DeleteConfirmation;
